import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { AccountDetails, getAccountDetails } from "@WhiteCap/Store/Service/AccountDetails";

export interface GetAccountDetailsApiParameter extends ApiParameter{
    
}

type HandlerType = CustomApiHandler<GetAccountDetailsApiParameter, AccountDetails>;

export const DispatchBeginLoadOrders: HandlerType = props => {
     props.dispatch({
         type: "Custom/AccountDetails/BeginLoadAccountData",
         parameter: props.parameter,
     });
 };

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getAccountDetails();
};

export const DispatchCompleteLoadOrders: HandlerType = props => {
    props.dispatch({
        type: "Custom/AccountDetails/CompletedLoadAccountData",
        result: props.apiResult,
    });
};

export const chain = [DispatchBeginLoadOrders, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadOrders];

const loadAccountDetails = createHandlerChainRunner(chain, "LoadAccountDetails");
export default loadAccountDetails;
